import gql from 'graphql-tag';

export const DEVOLVERVENTAS = gql`
    query devolverVentas($ano:Int, $semana:Int, $tienda:String){
        ventas(ano:$ano, semana:$semana, tienda:$tienda){
            fecha
            cantidad
        }
    }
`;

export const DEVOLVERFECHASERVIDOR = gql`
    query{
        fechaServidor
    }
`;

export const DEVOLVERVENTASTS = gql`
    query devolverVentas($ano:Int, $semana:Int, $tienda:String){
        ventasTS(ano:$ano, semana:$semana, tienda:$tienda){
            fecha
            cantidad
        }
    }
`;

export const DEVOLVERVENTASVENDEDOR = gql`
    query devolverVentas($ano:Int, $semana:Int, $tienda:String){
        ventas(ano:$ano, semana:$semana, tienda:$tienda){
            fecha
            cantidad
            cajero
            vendedor
        }
    }
`;


export const CREARSEMANAS = gql`
    mutation nuevaSemana($fecha:String!, $tiendas:[String], $semana:String){
        crearSemana(fecha:$fecha, tiendas:$tiendas, semana:$semana)
    }
`;

export const ACTUALIZARPRESUPUESTOSEM = gql`
    mutation actpre($datos:String){
        actualizarPresupuestoSemana(datos:$datos)
    }
`;

export const CREARHORARIO = gql`
    mutation nuevoHorario($fecha: String!, $tiendas: [String], $horario: String) {
        crearHorarios(fecha: $fecha, tiendas: $tiendas, horario: $horario)
    }
`;


export const CONSULTARINFOSEM = gql`
    query infoSemana($fecha: String) {
        semanas: semanaXFecha(fecha: $fecha) {
            id
            tienda
            fecha
            horario {
                tienda
            }
            semana
            ventasSem
            estado {
                creada
                presupuesto
                horario
                enejecucion
                finalizada
            }
            mPorcentaje {
                estado
                dias {
                    porcentaje
                    horas {
                        txtHora
                        porcentaje
                        precio
                    }
                    fecha
                    precio
                    txtDia
                }
            }
        }
    }
`;

export const DEVOLVERANOACTUAL = gql`
    query($ano:Int){
        ano(ano:$ano){
            id
            ano
            primerDia
        }
    }
`;

export const CREARSEMANAEMPLEADO = gql`
    mutation ($eSemana:String){
        addEmpleadoSem(empleSem:$eSemana){
            id
        }
    }
`;

export const ACTUALIZARESTADOSEMANA = gql`
    mutation updEstadoSem($fecha:String, $tienda:String, $estado:String){
        actualizarEstadoSem(fecha:$fecha, tienda:$tienda, estado:$estado){
            id
        }
    }
`;

export const DEVOLVERINFOTIENDA = gql`
    query devolverInfoTienda($fecha: String, $tienda: String, $ano: Int, $semana: Int, $ti: String) {
        semana: semanaFechaTienda(fecha: $fecha, tienda: $tienda) {
            id
            tienda
            fecha
            semana
            ventasSem
            estado {
                creada
                presupuesto
                horario
                enejecucion
                finalizada
                planAccion
            }
            horario {
                dias {
                    nombre
                    horaInicio
                    horaCierre
                }
            }
            mPorcentaje {
                estado
                dias {
                    porcentaje
                    horas {
                        txtHora
                        porcentaje
                        precio
                    }
                    precio
                    txtDia
                }
            }
        }
        ventas: ventas(ano: $ano, semana: $semana, tienda: $ti) {
            fecha
            cantidad
            cajero
            vendedor
            tipodoc
            articulos {
                valor
            }
        }
        empleados: empleadoTienda(tienda: $tienda) {
            id
            nombre
            tienda
        }
    }
`;

export const ACTUALIZARHORARIOSEMANA = gql`
    mutation ($id:String, $horario:String){
        actualizarHorarioSemana(id:$id,horario:$horario)
    }
`;

export const GETSEMANACALENDARIOTIENDA = gql`
    query($fechaIni:String, $fechaFin:String, $tienda:String){
        semanaFechaCalTienda(fechaIni:$fechaIni, fechaFin:$fechaFin, tienda:$tienda){
            id
            tienda
            tIdDb
            fecha
            semana
            ventasSem
            mPorcentaje{
                dias{
                    porcentaje
                    precio
                    fecha
                }
            }
        }
    }
`;


